import jwtDecode from "jwt-decode"
import { find } from "lodash/collection"
import { addTags } from "./api/tags"
import State from "./stores/State"
import {
  APPEND_SEARCH_FILTER,
  ADD_SEARCH_FILTER_CONTROL,
  REMOVE_SEARCH_FILTER,
  SET_FROM_TOKEN,
  SET_PER_PAGE,
  SET_ARTICLE_STYLE,
  LOAD_PREFERENCES,
  SEARCH_SORT,
  SET_STATE_FROM_PARAMS,
  SET_RESULT_IDS,
  SET_LOCALE,
  SET_ACTIVE_COLLECTIONS
} from "./constants"
import { isomorphicVars } from "./scripts/isomorphicVars"

export function addTag(uuid, tags) {
  if (!State.get("loggedIn")) {
    return Promise.reject(new Error("loggedOut"))
  }

  return addTags({
    userId: State.get("userId"),
    uuid,
    tags
  })
}

export function setToken(tokenString) {
  const { authentic_account_id: AuthenticAccountId } = isomorphicVars()

  const token = tokenString ? jwtDecode(tokenString) : null
  const account =
    token && token.accounts
      ? find(token.accounts, { aud: `${AuthenticAccountId}` })
      : {}

  return {
    type: SET_FROM_TOKEN,
    payload: {
      token: token,
      tokenString: tokenString,
      loggedIn: !!token,
      userLogin: token ? token.email : null,
      usersName: token ? token.name : null,
      userId: token ? token.sub : null,
      userRoles: token && account && account.roles ? account.roles : [], // careful this will turn into an immutable LIST
      userRole: token && account && account.roles ? account.roles[0] : null // legacy
    }
  }
}

export const appendSearchFilter = ({ name, value }) => ({
  type: APPEND_SEARCH_FILTER,
  name,
  value
})

export const removeSearchFilter = ({ name, value }) => ({
  type: REMOVE_SEARCH_FILTER,
  name,
  value
})

export const addSearchFilterControl = name => ({
  type: ADD_SEARCH_FILTER_CONTROL,
  name
})

export const setPerPage = perPage => ({
  type: SET_PER_PAGE,
  perPage
})

export const setArticleStyle = articleStyle => ({
  type: SET_ARTICLE_STYLE,
  articleStyle
})

export const loadPreferences = data => ({
  type: LOAD_PREFERENCES,
  data
})

export const searchSort = sort => ({
  type: SEARCH_SORT,
  sort
})

export const setStateFromParams = params => ({
  type: SET_STATE_FROM_PARAMS,
  params
})

export const setResultIds = ids => ({
  type: SET_RESULT_IDS,
  ids
})

export const setLocale = locale => ({
  type: SET_LOCALE,
  locale
})

export const setActiveCollection = collectionsIds => ({
  type: SET_ACTIVE_COLLECTIONS,
  collectionsIds
})



// WEBPACK FOOTER //
// ./webapp/actions.js